
import { supabase } from "@/integrations/supabase/client";
import Cookies from "js-cookie";

const REFERRAL_COOKIE_NAME = "metrade_referral_code";

export const processReferral = async (userId: string, subscriptionId: string) => {
  try {
    console.log("Starting referral process for:", { userId, subscriptionId });
    
    // Check if this user was referred by someone
    const { data: referralData, error: referralError } = await supabase
      .from('referral_relationships')
      .select('id, referrer_id, paid_status, created_at')
      .eq('referred_id', userId)
      .single();
      
    console.log("Referral lookup result:", { 
      found: !!referralData, 
      error: referralError?.message,
      data: referralData 
    });
      
    if (referralError && referralError.code !== 'PGRST116') {
      console.error("Error checking referral:", referralError);
      return;
    }
    
    // If user was referred and not marked as paid yet
    if (referralData && !referralData.paid_status) {
      console.log("Found unpaid referral relationship:", {
        id: referralData.id,
        created: referralData.created_at
      });
      
      // Mark this referral as paid
      const { error: updateError } = await supabase
        .from('referral_relationships')
        .update({
          paid_status: true,
          paid_date: new Date().toISOString()
        })
        .eq('id', referralData.id);
        
      if (updateError) {
        console.error("Error updating referral status:", updateError);
      } else {
        console.log("Referral marked as paid successfully");
        
        // Process reward for the referrer
        try {
          console.log("Invoking reward processing for referrer:", referralData.referrer_id);
          
          const { data: rewardData, error: rewardError } = await supabase.functions.invoke('process-referral-reward', {
            body: {
              userId: referralData.referrer_id,
              subscriptionId: subscriptionId
            }
          });
          
          if (rewardError) {
            console.error("Error processing referral reward:", rewardError);
          } else {
            console.log("Referral reward processed successfully:", rewardData);
          }
        } catch (rewardError) {
          console.error("Exception processing referral reward:", rewardError);
        }
      }
    } else if (referralData) {
      console.log("Referral relationship found but already paid");
    } else {
      console.log("No referral relationship found for this user");
    }
    
    // Clean up the referral cookie after successful processing
    Cookies.remove(REFERRAL_COOKIE_NAME);
    
  } catch (error) {
    console.error("Error in processReferral:", error);
  }
};
